// Get Glazy — sticky "Shop Now" CTA on PDPs.
// Shows once the user scrolls past the last product collapsible (Application/How to use).
// Click smooth-scrolls back to the offer cards (.glazy-mm) so the customer picks a tier.
(function () {
  if (window.__glazyStickyCtaInit) return;
  window.__glazyStickyCtaInit = true;

  function init() {
    var cta = document.querySelector('.glazy-sticky-cta');
    if (!cta) return;

    // Escape parent stacking contexts (transform/filter on ancestors trap position:fixed).
    // Move the CTA directly under <body> so its z-index applies against the root.
    if (cta.parentNode !== document.body) {
      document.body.appendChild(cta);
    }

    var collapsibles = document.querySelectorAll('.m-product-collapsible');
    var trigger = collapsibles.length ? collapsibles[collapsibles.length - 1] : null;
    if (!trigger) trigger = document.querySelector('.glazy-mm');
    if (!trigger) return;

    var scrollTarget = document.querySelector('.glazy-mm')
      || document.querySelector('.main-product__block-buy_buttons')
      || document.querySelector('.main-product__block-glazy_mix_match');

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (scrollTarget && typeof scrollTarget.scrollIntoView === 'function') {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    function evaluate() {
      var rect = trigger.getBoundingClientRect();
      // "past" means trigger has scrolled above the viewport
      var pastTrigger = rect.bottom < 0;
      cta.classList.toggle('is-visible', pastTrigger);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () {
        evaluate();
      }, { threshold: 0 });
      io.observe(trigger);
    }

    // Always also bind a passive scroll listener as a safety net (and for the
    // gap between "intersection ends" and "rect.bottom flips negative" on Safari).
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        evaluate();
        ticking = false;
      });
    }, { passive: true });

    evaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
